import React, { useState, useEffect } from 'react'
import { Layout, ConfigProvider } from 'antd'
import { useHistory } from 'react-router-dom'
import RightContent from '@/components/RightContent'
import MenuHeader from '@/components/MenuHeader'
import MainMenu from '@/components/menu/Menu'
import basic from '@/constants/basic'
import ruRU from 'antd/lib/locale/ru_RU'
import '@/assets/styles/layout.less'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import axios_init from '@/utils/axios_init'
import { setUserPermissions } from '../redux/actions/authActions'
const { Content, Sider } = Layout

// ***********************WEBSOCKET****************************************
const token = localStorage.getItem('token')

// ***********************WEBSOCKET****************************************

export default function MainLayout({ children }) {
  const [collapsed, setCollapsed] = useState(false)
  // const isAuthorited = useSelector((state) => state.auth.accessToken)
  const roleIdFromStorage = localStorage.getItem('role_id')
  const roleID =
    roleIdFromStorage !== 'undefined'
      ? JSON.parse(localStorage.getItem('role_id'))
      : null
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    if (!token) {
      history.push('/login')
    }
  }, [])

  const getPermissions = () => {

    if (roleID)
      axios_init
        .get(`auth/role/${roleID}`)
        .then(({ data }) => {
          localStorage.setItem('sys_user_type', data?.name)
          dispatch(setUserPermissions(data.permissions))
        })
        .catch((err) => {
        })
  }

  useEffect(() => {
    if (token) {
      getPermissions()
    }
  }, [location])

  return (
    <div className={`App ${token ? '' : 'd-none'}`}>
      <Layout style={{ minHeight: '100vh', margin: 0, padding: 0 }}>
        <Layout className='site-layout' style={{ display: 'flex', minHeight: '100vh', margin: 0, padding: 0 }}>
          <Sider
            className='sider'
            trigger={null}
            collapsible
            theme={basic.MENU_THEME}
            width={250}
            collapsed={collapsed}
            onCollapse={() => setCollapsed(!collapsed)}
            style={{ 
              backgroundColor: '#1a2a3a',
              position: 'fixed',
              left: 0,
              top: 0,
              bottom: 0,
              overflowY: 'auto',
              zIndex: 8,
              margin: 0,
              padding: 0
            }}
          >
            <MenuHeader />
            <RightContent />
            <MainMenu />
          </Sider>
          <Content className='mainBox' style={{ margin: 0, padding: 0 }}>
            <ConfigProvider locale={ruRU}>{children}</ConfigProvider>
          </Content>
        </Layout>
      </Layout>
    </div>
  )
}
